<template>
<el-contianer>



<div>
  <el-container>
    <el-row style="width: 98%;">
      <el-col :span="12" :offset="2">

              <el-container class="SelectBlock">


                 <!-- <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a">根据部门编号查询</el-dropdown-item>
                      <el-dropdown-item command="b">根据公司编号查询</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->


                    <el-select  v-model="SForm.SdepartmentName"  placeholder="根据部门查询">
                        <el-option
                        v-for="i in DName"
                        :key="i.departmentName"
                        :label="i.departmentName"
                        :value="i.departmentName">
                        </el-option>
                    </el-select>


                   <el-select  v-model="SForm.SUnitId" placeholder="根据公司查询">
                       <el-option
                       v-for="i in DUnit"
                       :key="i.unitName"
                       :label="i.unitName"
                       :value="i.unitId">
                       </el-option>
                   </el-select>


                  <el-button type="primary" @click="select(1)">查询</el-button>
                  <el-button type="primary" @click="resetForm('SForm')">重置</el-button>


              </el-container>

      </el-col>


      <el-col :span="2" :offset="2">
        <el-button type="danger" @click="deleteRow()">删除</el-button>
      </el-col>

      <el-col :span="2" :offset="1">


        <el-button type="primary" @click="dialogFormVisible = true">添加部门</el-button>
        <el-dialog title="添加部门" :visible.sync="dialogFormVisible" width="35%">
          <el-button type="primary" @click="dialogButton = true">手动添加</el-button>

          <el-dialog title="添加部门" :visible.sync="dialogButton" width="35%" append-to-body>

             <el-form>
               <el-form-item label="部门名称">
                 <el-input v-model="name" placeholder="部门"/>
               </el-form-item>
                <el-form-item label="部门描述" label-width='formLabelWidth'>
                  <el-input
                    :rows="2"
                    type="textarea"
                    v-model="detail"
                    placeholder="请输入内容">
                  </el-input>
                </el-form-item>

                <el-form-item label="负责人">
                    <el-input v-model="ManagerUserName" :value="ManagerUser">
                      <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
                        <el-button
                          size="mini"
                           style="padding-right:10px"
                           slot="suffix"
                           type="text"
                          @click="dialogM = true">选择</el-button> </el-input>
                          <el-dialog title="选择管理员部门人员"
                          append-to-body
                          :visible.sync="dialogM" width="25%">

                          <el-input
                            placeholder="输入关键字进行过滤"
                            v-model="filterText">
                          </el-input>
                            <el-tree
                              class ="TreeBlock"
                              :data="MangerData"
                              :filter-node-method="filterNode"
                              node-key="id"
                              @node-click="TreeMangerClick"
                              ref="tree"
                              :props="defaultProps"
                              default-expand-all:false
                              :expand-on-click-node="false">
                              <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span>{{ node.label }}</span>
                              </span>
                            </el-tree>
                            <div slot="footer" class="dialog-footer">
                              <el-button @click="dialogM = false">取 消</el-button>
                              <el-button type="primary" @click="dialogM = false;">确 定</el-button>
                            </div>
                          </el-dialog>
                </el-form-item>
                  <el-form-item label="单位">
                    <el-select v-model="UnitId" placeholder="单位">
                        <el-option
                        v-for="i in DUnit"
                        :key="i.unitName"
                        :label="i.unitName"
                        :value="i.unitId">
                        </el-option>
                    </el-select>
                  </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogButton = false">取 消</el-button>
                <el-button type="primary" @click="dialogButton = false;add()">确 定</el-button>
              </div>
            </el-dialog>
          <el-upload
            style="margin-top: 2%;"
            class="upload-demo"
            action="https://assert.hyhdit.com/apiYang/department/importExcelBigData"
            :on-change="handleChange"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :headers="token">
            <el-button  type="danger">点击上传文件批量导入部门信息</el-button>
          </el-upload>
        </el-dialog>
      </el-col>
    </el-row>
  </el-container>








</div>
    <el-table
      :data="tableData"
      border
       @selection-change="handleSelectionChange"
      style="width: 98%;margin-top: 1%; margin-left: 1%;"
      >
      <el-table-column
            type="selection"
            width="55">
          </el-table-column>

      <el-table-column
        prop="unit"
        label="单位名称"
        width="250">
      </el-table-column>

      <el-table-column
        prop="departmentName"
        label="部门名称"
        width="180">
      </el-table-column>

      <el-table-column
        prop="departmentDetail"
        label="部门描述"
        width="150">
      </el-table-column>

      <el-table-column
        prop="managerName"
        label="管理人名称"
        width="150">
      </el-table-column>



      <el-table-column
        label="创建时间"
        width="150">
        <template slot-scope="scope">
         {{formattedTime(scope.row.createDate)}}</template>

      </el-table-column>

      <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="dialogFormEdit = true;EditData(scope.row)">编辑</el-button>
                <el-dialog title="修改部门" :visible.sync="dialogFormEdit" width="35%">
                  <el-form>
                    <el-form-item label="单位代号">
                      <el-select v-model="EUnitId" placeholder="单位">
                          <el-option
                          v-for="i in DUnit"
                          :key="i.unitName"
                          :label="i.unitName"
                          :value="i.unitId">
                          </el-option>
                      </el-select>
                    </el-form-item>



                    <el-form-item label="负责人">
                        <el-input v-model="EditUserName" :value="EditUser">
                          <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
                            <el-button
                              size="mini"
                               style="padding-right:10px"
                               slot="suffix"
                               type="text"
                              @click="dialogEidtUser = true">选择</el-button> </el-input>
                              <el-dialog title="选择管理员部门人员"
                              append-to-body
                              :visible.sync="dialogEidtUser" width="25%">

                              <el-input
                                placeholder="输入关键字进行过滤"
                                v-model="filterText">
                              </el-input>
                                <el-tree
                                  class ="TreeBlock"
                                  :data="EditManagerData"
                                  :filter-node-method="filterNode"
                                  node-key="id"
                                  @node-click="TreeEditClick"
                                  ref="tree"
                                  :props="defaultProps"
                                  default-expand-all:false
                                  :expand-on-click-node="false">
                                  <span class="custom-tree-node" slot-scope="{ node, data }">
                                    <span>{{ node.label }}</span>
                                  </span>
                                </el-tree>
                                <div slot="footer" class="dialog-footer">
                                  <el-button @click="ddialogEidtUser = false">取 消</el-button>
                                  <el-button type="primary" @click="dialogEidtUser = false;">确 定</el-button>
                                </div>
                              </el-dialog>
                    </el-form-item>









                    <el-form-item label="部门描述">
                      <el-input
                        type="textarea"
                        v-model="Edetail"
                        placeholder="请输入内容">
                      </el-input>
                    </el-form-item>


                    <el-form-item label="部门名称">
                      <el-input placeholder="部门名称" v-model="departmentName"></el-input>
                    </el-form-item>

                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormEdit = false">取 消</el-button>
                    <el-button type="primary" @click="dialogFormEdit = false;handleEdit(scope.$index, scope.row)">确 定</el-button>
                  </div>
                </el-dialog>
              <el-button
                size="mini"
                @click="download(scope.row)">
                导出该部门信息
              </el-button>
            </template>
          </el-table-column>

    </el-table>



    <div class="block">
        <el-pagination
             @size-change="handleSizeChange"
             @current-change="select"
             :current-page="currentPage"
             :page-sizes="[10, 20, 50, 100]"
             :page-size="pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
           </el-pagination>
      </div>
</div>
</el-contianer>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import qs from "qs"
  export default {
     name: 'Department',
     data () {
       return {
         token:{
           Authorization:Cookies.get("Authorization")
         },
		filterText:'',
        selectCheck:'',
        multipleSelection: [],
        currentPage: 1,
        pageSize:20,
        total:0,
        ManagerUser:'',
        ManagerUserName:'',

        EditUser:'',
        EditUserName:'',
        dialogM:false,
        dialogEidtUser:false,
        dialogButton:false,
        dialogFormVisible: false,
        dialogFormEdit: false,
        MangerData: [{
          id:'',
          label: '',
          realId:'',
          operator:'',
          children: [{
            id:'',
            label: '',
            realId:'',
            operator:'',
            children: [{
              id:'',
              label: '',
              realId:'',
              operator:'',
            }]
          }]
        }],
        EditManagerData:[{
          id:'',
          label: '',
          realId:'',
          operator:'',
          children: [{
            id:'',
            label: '',
            realId:'',
            operator:'',
            children: [{
              id:'',
              label: '',
              realId:'',
              operator:'',
            }]
          }]
        }],
        departmentId:'',
        SForm:{
          Sname:'',
          SUnitId:'',
          SdepartmentName:''
        },
        drawer: false,
        direction: 'rtl',
        Ename:'',
        Edetail:'',
        EUnitId:'',
        name:'',
        detail:'',
        UnitId:'',
        formLabelWidth:'120px;',
        defaultProps: {
                 children: 'children',
                 label: 'label'
               },
        departmentName:'',
        DName:[{
          departmentId:'',
          departmentName:'',
        }],
        DUnit:[{
          unitName:'',
          unitId:'',
        }],
        tableData: [{
                departmentId: '',
                departmentName: '',
                departmentDetail:'',
                unitId: '',
                createDate:'',
                unit:'',
                managerName:'',
                managerId:'',
                del:'',
              }],
              }
       },
     created:function() {
       this.showData();
       this.showDepartmentData();
       this.showUnitData();
       this.showMData();
     },
     watch: {
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
     methods: {
      download(scope) {
        // console.log(scope)
        let data = {
          unitId: scope.unitId,
        }
        this.axios({
          method: 'POST',
          url: '/department/exportExcelSmallData',
          data: data,
        }).then((res)=>{
          if (res.data.code == 200) {
            console.log(res.data)
            window.location.href = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      TreeMangerClick(data){
          if(data.operator == 1){
            this.ManagerUser = data.realId
            this.ManagerUserName = data.label
            this.dialogManager = false
          }else{
            return;
          }
      },

	  filterNode(value, data) {
	          if (!value) return true;
	          return data.label.indexOf(value) !== -1;
	        },


      TreeEditClick(data){
          if(data.operator == 1){
            this.EditUser = data.realId
            this.EditUserName = data.label
            this.dialogManager = false
          }else{
            return;
          }
      },
     formattedTime(val) {
             const date = new Date(val);
             const year = date.getFullYear();
             const month = ("0" + (date.getMonth() + 1)).slice(-2);
             const day = ("0" + date.getDate()).slice(-2);
             return `${year}-${month}-${day} `;
           },


       showMData(){
        var authorization = Cookies.get("Authorization");
         this.axios({
             method: 'GET',
             url: '/public/getUnitTree',
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            // var arr = new Array(resp.data.data) ;
            this.MangerData=resp.data.data;
            this.EditManagerData = resp.data.data;
           })
       },






      handleSuccess(res){
        if(res.code==200){
        	this.open4(res.message)
			this.select(this.currentPage)
        }else{
        	this.open3(res.message)
        }
      },


      EditData(rows) {
          this.EditUserName = rows.managerName
          this.departmentId = rows.departmentId,
          this.Edetail = rows.departmentDetail,
          this.departmentName = rows.departmentName
          this.EUnitId = rows.unitId
           },

      open3(val) {
			 this.$notify({
			   message: val,
			   type: 'danger',
			   duration: 3000
			 });
           },
      handleChange(file, fileList) {
              this.fileList = fileList.slice(-3);
            },
		handleProgress() {
			this.$notify({
			  title: '上传中......',
			  message: '上传中，请稍等.....',
			  type: 'warning',
			  duration: 3000
			});
		},
       deleteRow(){
              var authorization = Cookies.get("Authorization");
              var deleteData = []
              for(let i of this.multipleSelection){
                deleteData.push(i.departmentId)
              }
              this.axios({
                  method: 'POST',
                  url: '/department/deleteDepartment',
                  params:{
                    ids:deleteData
                  },
                  paramsSerializer:params =>{
                    return qs.stringify(params,{indices:false})
                  },
                  header:{
                   'Authorization':authorization,
                  	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  	}
                }).then((resp)=>{
                    if(resp.data.code==200){
                      this.open4(resp.data.message)
                      this.select(this.currentPage)
                    }else{
                      this.open3(resp.data.message)
                    }
                    this.select(this.currentPage)
                })
            },


						open4(val) {
							this.$notify({
								title: val,
								message: val,
								type: 'success',
								duration: 3000
								});
									},


       handleSelectionChange(val) {
           this.multipleSelection = val;
             },

       resetForm(formName) {
         Object.assign(this.$data.SForm, this.$options.data().SForm)
         this.select();
           },

       showDepartmentData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 10,
        }
         this.axios({
             method: 'GET',
             url: '/public/getCanHandleDepartmentList',
             params:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            this.DName = resp.data.data;
            // this.total = resp.data.count
           })
       },





       showUnitData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 10,
        }
         this.axios({
             method: 'GET',
             url: '/public/getCanWatchUnit',
             params:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            this.DUnit = resp.data.data;
           })
       },

      handleCommand(command) {
             this.selectCheck = command
            },






       showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 20,
          unitId: localStorage.getItem("searchUnitId"),
        }
         this.axios({
             method: 'GET',
             url: '/department/showDepartments',
             params:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            this.tableData=resp.data.data;
            this.total = resp.data.count;
           })
       },
		handleSizeChange(val){
		this.pageSize = val
		this.select()
		},

         select(val){
            var authorization = Cookies.get("Authorization");
            this.currentPage = val
            var paramsData = {
              currentPage: val || 1 || undefined,
              pageSize: this.pageSize,
              unitId: localStorage.getItem("searchUnitId"),
              departmentName: this.SForm.SdepartmentName || undefined
            }

             this.axios({
                 method: 'GET',
                 url: '/department/showDepartments',
                 params:paramsData,
                 header:{
                  'Authorization':authorization,
                 	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                 	}
               }).then((resp)=>{
                  this.tableData=resp.data.data;
                  this.total =resp.data.count;
               })
         },

         add(){
           var authorization = Cookies.get("Authorization");
           this.axios({
               method: 'POST',
               url: '/department/addDepartment',
               data: {
                 departmentName:this.name,
                 departmentDetail:this.detail,
                 unitId:this.UnitId,
                 managerId:this.ManagerUser
               },  //这里json对象会转换成json格式字符串发送

               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
                if(resp.data.code==200){
                  this.open4(resp.data.message)
                  this.select(this.currentPage)
                }else{
                  this.open3(resp.data.message)
                }
                 this.select(this.currentPage)
               })

         },
         handleEdit(index, row) {
              var authorization = Cookies.get("Authorization");
              this.axios({
                  method: 'POST',
                  url: '/department/updateDepartment',
                  data:{
                    departmentId:this.departmentId,
                    departmentName:this.departmentName,
                    departmentDetail:this.Edetail,
                    unitId:this.EUnitId,
                    managerId:parseInt(this.EditUser),
                    del:row.del,
                  },

                  header:{
                   'Authorization':authorization,
                  	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  	}
                }).then((resp)=>{
                  if(resp.data.code==200){
                    this.open4(resp.data.message)
                    this.select(this.currentPage)
                  }else{
                    this.open3(resp.data.message)
                  }
                  this.select(this.currentPage)
               })

              },
     }
   }
</script>

<style>
  .block{
    margin-top: 5%;
    margin-left: 20%;
  }
  .SelectBlock .el-input{
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Munber/Department.vue